import { useExecuteAction } from './connect_hooks';

export default useExecuteAction;
